import { Table, TableColumnsType } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { DepartmentName, UserAvatar } from '@/components'
import { Portfolio } from '@/schemas'

interface teamTableProps {
  dataSource: Portfolio[]
  renderExtras?: any
}

export const TeamTable: React.FC<teamTableProps> = ({ renderExtras, ...extraTableProps }) => {
  const { t } = useTranslation()
  const columns: TableColumnsType<Portfolio> = [
    {
      title: t('name'),
      render: (_, d) => {
        return (
          <div className='flex items-stretch'>
            <DepartmentName canRead={true} departmentId={d.departmentId} />
          </div>
        )
      },
    },
    {
      title: t('owner'),
      render: (_, d) => {
        return (
          <div className='flex items-stretch'>
            <UserAvatar showName email={d.email} />
          </div>
        )
      },
    },
  ]

  if (renderExtras) {
    columns.push({
      width: 80,
      align: 'center',
      render: renderExtras,
    })
  }

  return <Table rowClassName='group' rowKey='selfId' size='middle' columns={columns} {...extraTableProps} />
}
